var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"h-auto w-40 mx-auto",attrs:{"alt":"Platform Light","src":"/assets/logo.png"}})])}]

export { render, staticRenderFns }